export const CREATE_PRODUCTION_REPACKING = 'CREATE_PRODUCTION_REPACKING';
export const GET_PRODUCTION_REPACKINGS = 'GET_PRODUCTION_REPACKINGS';
export const UPDATE_PRODUCTION_REPACKING = 'UPDATE_PRODUCTION_REPACKING';
export const DELETE_PRODUCTION_REPACKING = 'DELETE_PRODUCTION_REPACKING';
export const PRODUCTION_REPACKING_REQUEST = 'PRODUCTION_REPACKING_REQUEST';
export const PRODUCTION_REPACKING_FAILURE = 'PRODUCTION_REPACKING_FAILURE';
